import { Pipe, PipeTransform } from '@angular/core';
import { formatPriceWithCurrencyNotation } from '../../util/price-formatter.util';

@Pipe({
  name: 'priceNotation',
  pure: true,
})
export class PriceNotationPipe implements PipeTransform {
  transform(price: string | number): string {
    if (typeof price === 'number') {
      return formatPriceWithCurrencyNotation(price.toString());
    }

    if (typeof price === 'string') {
      return formatPriceWithCurrencyNotation(price);
    }

    return String(price);
  }
}
